module.exports = {"en":"english","fr":"français"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/languages-names.json
// module id = 324
// module chunks = 2